var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "cancel-variant": "outline-secondary",
        centered: "",
        "ok-title": "저장",
        "cancel-title": "취소",
        size: "sm",
        title: _vm.isNew ? "항목 추가" : "항목 수정",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.submit()
        },
        close: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
        cancel: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
      },
      model: {
        value: _vm.showInterestContentEdit,
        callback: function ($$v) {
          _vm.showInterestContentEdit = $$v
        },
        expression: "showInterestContentEdit",
      },
    },
    [
      _c(
        "validation-observer",
        { ref: "formRules" },
        [
          _c(
            "b-row",
            { staticClass: "mt-1" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "항목명",
                        "label-for": "interestContentTitle",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: { name: "항목명", rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "interestContentTitle",
                                    placeholder:
                                      "항목명을 입력하세요.(최대 20자)",
                                    maxlength: "20",
                                    state: errors.length > 0 ? false : null,
                                  },
                                  model: {
                                    value: _vm.interestContentData.title,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.interestContentData,
                                        "title",
                                        $$v
                                      )
                                    },
                                    expression: "interestContentData.title",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "설명",
                        "label-for": "interestContentDescription",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "interestContentDescription",
                          placeholder: "설명을 입력하세요.(최대 60자)",
                          maxlength: "60",
                          rows: "3",
                        },
                        model: {
                          value: _vm.interestContentData.description,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.interestContentData,
                              "description",
                              $$v
                            )
                          },
                          expression: "interestContentData.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }